import React from 'react';
import ReactDOM from 'react-dom';

import { ThemeProvider } from 'react-jss';
import { Provider } from 'mobx-react';
import store from './app/models/store';
import './global.css';

import registerServiceWorker from './registerServiceWorker';

import App from './app/App';

import theme from './app/theme';
// console.log('process.env', process.env);
const { NODE_ENV, PLATFORM } = process.env;

if ( NODE_ENV === 'production' && PLATFORM === 'production' ) {
    // registerServiceWorker();
} else {
    window.store = store;
}


const render = Comp => {
    ReactDOM.render(
        <Provider store={store.channelStats} channels={store.channels} auth={store.auth}>
            <ThemeProvider theme={theme}>
                <Comp/>
            </ThemeProvider>
        </Provider>,
        document.getElementById('app-root'));
};

render(App);

if ( module.hot ) {
    module.hot.accept();
}



// WEBPACK FOOTER //
// ./src/index.js